import { render, staticRenderFns } from "./LoginRegisterModal.vue?vue&type=template&id=83c39b66&scoped=true&"
import script from "./LoginRegisterModal.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterModal.vue?vue&type=style&index=0&id=83c39b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c39b66",
  null
  
)

export default component.exports